import { isEmpty } from '@eastcoal/common/utils/object'

import {
  DataField,
  Form,
  onFieldInputValueChange,
  onFieldReact
} from '@eastcoal/formily/exports/core'

import { KIND_FIELD, PRICING_METHOD_FIELD } from '../../constants/filed'

/**
 * “计价方式”联动逻辑
 */
const clearValue = (_: unknown, form: Form) => {
  const priceMethodField = form.query(PRICING_METHOD_FIELD).take() as DataField
  if (!isEmpty(priceMethodField?.value)) priceMethodField?.onInput(null)
}

const updateState = (_: unknown, form: Form) => {
  const { kindCode } = form.values
  const priceMethodField = form.query(PRICING_METHOD_FIELD).take() as DataField
  priceMethodField?.setComponentProps({ kindCode })
}

export const pricingMethodEffect = () => {
  onFieldInputValueChange(KIND_FIELD, clearValue)
  onFieldReact(KIND_FIELD, updateState)
}
